"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * implementation of lodash partition API - https://lodash.com/docs/4.17.15#partition
 * @param list
 * @param condition
 */
function partition(list, condition) {
    var _a = list.reduce(function (_a, currItem) {
        var firstGroup = _a[0], secondGroup = _a[1];
        return condition(currItem) ?
            [__spreadArrays(firstGroup, [currItem]), secondGroup] :
            [firstGroup, __spreadArrays(secondGroup, [currItem])];
    }, [[], []]), firstGroup = _a[0], secondGroup = _a[1];
    return [firstGroup, secondGroup];
}
exports.default = partition;
//# sourceMappingURL=partition.js.map